/**
 * Pantalla de acceso para usuarios finales.
 *
 * Flujo:
 * - autentica con Firebase Auth,
 * - valida que el documento del usuario exista en Firestore,
 * - exige un `subscriptionId` para permitir acceso al dashboard.
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase"; // Importa auth y db (Firestore)
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { Modal } from "antd";
import "./Login.scss";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const navigate = useNavigate();

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    try {
      // Autenticación con Firebase Auth
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // Verificar que el usuario exista en Firestore y tenga una suscripción activa
      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        throw new Error("Usuario no encontrado en la base de datos.");
      }
      const userData = userDoc.data();
      // Validar que el usuario tenga una suscripción activa (por ejemplo, que subscriptionId no esté vacío)
      if (!userData.subscriptionId || userData.subscriptionId.trim() === "") {
        throw new Error(
          "No se encontró una suscripción activa para este usuario."
        );
      }

      // Todo ok, redirigir al dashboard
      navigate("/dashboard");
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      setModalMessage(
        "Error al iniciar sesión. Verifica tus credenciales y asegúrate de tener una suscripción activa."
      );
      setModalVisible(true);
    }
  };

  const handleModalOk = () => {
    setModalVisible(false);
  };

  return (
    <div className="login-container">
      <div className="logo-login">
        <img src="/assets/images/logoBlanco.png" alt="Mentfull Logo" />
      </div>

      <h2>¿Estás list@ para descubrir el poder de tu magia interna?</h2>

      <div className="login-box">
        <form onSubmit={handleEmailLogin}>
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Iniciar sesión</button>
        </form>

        <a href="/register">No tengo una cuenta</a>
      </div>

      <Modal
        title="Error"
        visible={modalVisible}
        onOk={handleModalOk}
        onCancel={handleModalOk}
        footer={[
          <button key="ok" onClick={handleModalOk}>
            Aceptar
          </button>,
        ]}
      >
        <p>{modalMessage}</p>
      </Modal>
    </div>
  );
};

export default Login;
